/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FiAward,
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiHeart,
  FiPhone,
  FiSmile,
} from "react-icons/fi";
import photo1 from "../photos/photo1.jpeg";
import photo2 from "../photos/photo2.jpeg";
import photo3 from "../photos/photo3.jpeg";
import photo4 from "../photos/photo4.jpeg";
import photo5 from "../photos/photo5.jpeg";
import photo6 from "../photos/photo6.jpeg";
import banner1 from "../photos/banner1.jpeg";
import banner2 from "../photos/banner2.jpeg";
import banner3 from "../photos/banner3.jpeg";
import banner4 from "../photos/banner4.jpeg";

const slides = [banner1, banner2, banner3, banner4];

const treatments = [
  {
    title: "Leke Tedavisi",
    text: "Leke cilt kalitesini azalttığı, güzelliğe gölge düşürdüğü ve dış görünüm estetiğini olumsuz etkilediği için her geçen gün yeniliklerin denendiği bir konu alanı olmuştur.",
    to: "/leke-tedavileri-ve-cilt-problemleri-tedavileri",
  },
  {
    title: "Cilt Bakımı",
    text: "Cildimizin canlılığı, parlaklılığı ve diriliği en önemli sağlık göstergesidir. 20’li yaşlardan itibaren her bayanın, bakım ve koruma amaçlı ayda en az bir defa cilt bakımı yaptırması önerilir.",
    to: "/hydrafacial",
  },
  {
    title: "Gençlik Aşısı",
    text: "25 yaşından itibaren cildimizde kolajen kaybı başlamaktadır.Gençlik aşıları cilde yeniden canlılık, parlaklık, dayanıklılık ve gençlik ışıltısı kazandıracak güçlü bir antioksidandır.",
    to: "/genclik-asisi",
  },
];

const assurances = [
  [<FiSmile />, "MÜŞTERİ MEMNUNİYETİ"],
  [<FiCheck />, "GÜVENİLİR HİZMET"],
  [<FiAward />, "ÜNİVERSİTE DİPLOMALI UZMANLAR"],
  [<FiHeart />, "TERCİH NOKTANIZ"],
];

const gallery = [photo1, photo2, photo5, photo6, photo3, photo4];

const MainPage = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const changeSlide = (direction) => {
    setActiveSlide((current) => (current + direction + slides.length) % slides.length);
  };

  return (
    <div className="home-page">
      <section className="hero-slider" aria-roledescription="carousel">
        <div className="hero-slides">
          {slides.map((slide, index) => (
            <img
              key={slide}
              src={slide}
              className={index === activeSlide ? "is-active" : ""}
              alt="DR. TÜLAY YILDIRIM"
              aria-hidden={index !== activeSlide}
            />
          ))}
        </div>
        <div className="hero-wash" />
        <div className="hero-controls">
          <button type="button" onClick={() => changeSlide(-1)} aria-label="Önceki">
            <FiChevronLeft />
          </button>
          <div className="hero-pagination">
            {slides.map((slide, index) => (
              <button
                type="button"
                key={slide}
                className={index === activeSlide ? "is-active" : ""}
                onClick={() => setActiveSlide(index)}
                aria-label={`Slide ${index + 1}`}
                aria-current={index === activeSlide}
              />
            ))}
          </div>
          <button type="button" onClick={() => changeSlide(1)} aria-label="Sonraki">
            <FiChevronRight />
          </button>
        </div>
      </section>

      <section className="welcome-section reveal">
        <div className="section-ornament" aria-hidden="true"><span /></div>
        <h1>Hoşgeldiniz</h1>
        <p>Alanında uzman kadromuzla hayatınıza ve imajınıza dokunmaya devam ediyoruz..</p>
      </section>

      <section className="treatments-grid page-width">
        {treatments.map((treatment, index) => (
          <Link
            className="treatment-card reveal"
            style={{ "--delay": `${index * 90}ms` }}
            to={treatment.to}
            key={treatment.title}
          >
            <div className="treatment-card-top">
              <h2>{treatment.title}</h2>
              <span className="treatment-check"><FiCheck /></span>
            </div>
            <p>{treatment.text}</p>
            <span className="card-line" aria-hidden="true" />
          </Link>
        ))}
      </section>

      <section className="assurance-section">
        <div className="assurance-grid page-width">
          {assurances.map(([icon, label], index) => (
            <div
              className="assurance-item reveal"
              style={{ "--delay": `${index * 70}ms` }}
              key={label}
            >
              <span>{icon}</span>
              <p>{label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="gallery-section page-width">
        <div className="section-heading reveal">
          <div className="section-ornament" aria-hidden="true"><span /></div>
          <h2>Fotoğraflarımız</h2>
        </div>
        <div className="photo-grid">
          {gallery.map((photo, index) => (
            <figure
              className={`photo-tile photo-tile-${index + 1} reveal`}
              style={{ "--delay": `${(index % 3) * 70}ms` }}
              key={photo}
            >
              <img src={photo} alt="DR. TÜLAY YILDIRIM" loading="lazy" />
            </figure>
          ))}
        </div>
      </section>

      <section className="location-section page-width">
        <div className="section-heading reveal">
          <div className="section-ornament" aria-hidden="true"><span /></div>
          <h2>Konumumuz</h2>
        </div>
        <div className="map-frame reveal">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.54241482782!2d27.4122298151735!3d38.613401079615365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b99d8b370f6bb1%3A0x566748b5f8520f5!2zRHIuVMO8bGF5IFnEsWxkxLFyxLFt!5e0!3m2!1str!2str!4v1661453241548!5m2!1str!2str"
            height="450"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <a className="location-phone reveal" href="tel:+905304292306">
          <FiPhone />
          <span>0530 429 23 06</span>
        </a>
      </section>
    </div>
  );
};

export default MainPage;
